import { PHSensorBase } from './PHSensor.gen';
/** @public */
class PHSensor extends PHSensorBase { }
export { PHSensor };